import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** 조건부 클래스 결합 + Tailwind 클래스 충돌 해소. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
